import { render } from "./MemoList.vue?vue&type=template&id=99acb936"
import script from "./MemoList.vue?vue&type=script&lang=js"
export * from "./MemoList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__